module.exports = __webpack_public_path__ + "static/media/patternhero-lines-2.1a395b0c.svg";